// extracted by mini-css-extract-plugin
export var productImage = "_my-0";